import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import the pathless parent; the cycle is EntityQuickFind → routeTree → routes.tsx → this module → route.tsx and already exists for every migrated route.
import { Route as pathlessAuthenticatedRoute } from '../route';

const FeedbackPage = lazyRouteComponent(
  () => import('./FeedbackPage'),
  'FeedbackPage',
);

// No `staticData.app.nav` — this page is intentionally kept out of the sidebar
// and the command palette's auto-derived pages. It's reached via an explicit
// palette entry (useQuickSearchPages) and a link in the chat feedback widget.
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/feedback',
  component: FeedbackPage,
  loader: () => ({
    crumb: msg('My Feedback', { context: 'page breadcrumb' }),
  }),
});
